import type { CommonHTMLButtonAttributes } from '@frontend/types';
import { NakedButton } from '../../../naked/naked-button.component';
import { Text } from '../../text/text.component';

type WeekDayProps = CommonHTMLButtonAttributes & {
  ariaLabel: string;
  date: number;
  disabled?: boolean;
  isToday?: boolean;
  name: string;
  onClick: () => void;
  selected?: boolean;
};

export const WeekDay = ({ ariaLabel, date, disabled, isToday, name, onClick, selected, ...rest }: WeekDayProps) => {
  const getClassNames = () => {
    let classNames = 'week-day-item';

    if (disabled) {
      classNames += ' disabled';
    }

    if (selected) {
      classNames += ' selected';
    }

    if (isToday) {
      classNames += ' pre-selected';
    }

    return classNames;
  };

  return (
    <NakedButton
      {...rest}
      aria-label={ariaLabel}
      aria-selected={selected ? 'true' : 'false'}
      className={getClassNames()}
      disabled={disabled}
      onClick={onClick}
      role='listitem'
    >
      <Text as='span'>{name}</Text>
      <Text as='span'>{date}</Text>
    </NakedButton>
  );
};
